export default __webpack_public_path__ + "static/N0062-f7815745792ac493f10804754e0c09ec.png";